import { useState } from 'react';
import { useLocation } from '@reach/router';

export const useSeoMetada = (contentfulSeoMetadata, automatedSeoMetadata) => {
  const CONVELIO_DEFAULT_TITLE = 'Convelio - Fine art shipping made easy';
  const CONVELIO_DEFAULT_DESCRIPTION =
    'The digital logistic service dedicate to the art and luxurious furniture markets that makes any shipment easier, transparent and safe. We work with Art Galleries, Furniture brands, Auction Houses, Interior designers, Antique dealers and Design platforms.';

  const CONVELIO_DEFAULT_KEYWORDS = [
    'Convelio',
    'Fine art shipping',
    'artworks',
    'furniture'
  ];

  const location = useLocation();

  const initialState = {
    title:
      contentfulSeoMetadata?.title ||
      automatedSeoMetadata.title ||
      CONVELIO_DEFAULT_TITLE,
    description:
      contentfulSeoMetadata?.description ||
      automatedSeoMetadata.description ||
      CONVELIO_DEFAULT_DESCRIPTION,
    ogImage:
      contentfulSeoMetadata?.ogImage || automatedSeoMetadata.ogImage || null,
    keywords: contentfulSeoMetadata?.keywords || CONVELIO_DEFAULT_KEYWORDS
  };

  const [seoMetadata, setSeoMetadata] = useState(initialState);

  const helmetMetadata = seoMetadata
    ? [
        {
          name: 'keywords',
          content: seoMetadata.keywords?.join(',')
        },
        {
          name: 'description',
          content: seoMetadata.description
        },
        // Facebook Meta
        {
          property: 'og:site_name',
          content: 'Convelio'
        },
        {
          property: 'og:title',
          content: seoMetadata.title
        },
        {
          property: 'og:description',
          content: seoMetadata.description
        },
        {
          property: 'og:url',
          content: location?.href
        },
        {
          property: 'og:image',
          content: seoMetadata.ogImage?.file?.url
        },
        {
          property: 'og:type',
          content: 'website'
        },

        // Twitter Meta
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: seoMetadata.title
        },
        {
          name: 'twitter:description',
          content: seoMetadata.description
        },
        {
          name: 'twitter:url',
          content: location?.href
        },
        {
          name: 'twitter:image',
          content: seoMetadata.ogImage?.file?.url
        }
      ].filter((x) => x != [])
    : null;

  return { helmetMetadata };
};
